<app-navbar></app-navbar>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container"
        *ngIf="currentContentData.LayOut == 1 && currentContentData.FileType == 1">
        <app-layout-image-list [inputData]="currentContentData"></app-layout-image-list>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container"
        *ngIf="currentContentData.LayOut == 2 && currentContentData.FileType == 1">
        <app-layout-document-single-two [inputData]="currentContentData"></app-layout-document-single-two>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container"
        *ngIf="currentContentData.LayOut == 3 && currentContentData.FileType == 1">
        <app-layout-document-single-two [inputData]="currentContentData"></app-layout-document-single-two>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container"
        *ngIf="currentContentData.LayOut == 1 && currentContentData.FileType == 3">
        <app-layout-document-list [inputData]="currentContentData"></app-layout-document-list>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container"
        *ngIf="currentContentData.LayOut == 2 && currentContentData.FileType == 3">
        <app-layout-document-single [inputData]="currentContentData"></app-layout-document-single>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div style="margin-top: 50px"
        *ngIf="currentContentData.LayOut == 2 && currentContentData.FileType == 0">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content"
                        style="margin-top: 100px;">
                        <h2>No Data Found</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData == null">
        <div class="container"
            style="padding-top: 30px; padding-bottom: 30px;">
            <div class="row">
                <div class="col-md-12">
                    <div style="min-height: 800px;">

                        <h3 style="color: white !important;">{{currentMenuItem.DisplayName}}</h3>
                        <div class="container card"
                            style="padding: 20px;">
                            <div class="page-title-content"
                                style="margin-top: 100px; margin-bottom: 100px;">
                                <h2>No Data Found</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</ng-container>

<ng-container *ngIf="fetchinData">
    <div aria-hidden="true"
        class="col-lg-12 col-md-12">
        <h5 class="placeholder-glow">
            <span class="placeholder col-12"
                style="height: 800px;"></span>
        </h5>
    </div>
</ng-container>


